import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { MatchesModalSchema } from '@/views/sports/components/MatchesModal/styles/MatchesModal.styles';

export const matchesModalStyles: MatchesModalSchema = {
  modalWrapper: { size: 'lg', isCentered: true, scrollBehavior: 'inside' },
  modalContent: {
    color: 'white',
    overflow: 'hidden',
    bg: 'alpha.300',
    boxShadow:
      '0px 0px 0px 2px rgba(252, 211, 96, 1) inset, 0px 0px 0px 4px rgba(8, 13, 39, 1) inset, 0px 0px 0px 5px rgba(255, 255, 255, 0.25) inset, 0px 7px 20px 0px rgba(0, 0, 0, 0.3)',
  },
  modalHeader: {
    alignItems: 'center',
    borderBottom: '1px',
    borderColor: 'blackAlpha.400',
    display: 'flex',
    gap: '4',
    justifyContent: 'space-between',
    p: '4',
    fontFamily: 'accent',
    fontWeight: 'medium',
    fontSize: 'lg',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
  },
  closeButton: {
    bg: 'white',
    color: 'alpha.300',
    isRound: true,
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: { bg: 'whiteAlpha.800' },
  },
  divider: {
    as: 'div',
    borderColor: 'blackAlpha.300',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
  },
  modalBody: { p: '0', maxH: '400px' },
  stackWrapper: { spacing: '0' },
  linkWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: '3',
    justifyContent: 'space-between',
    p: '3',
    mx: '3px',
    _last: { mb: '3px' },
    _hover: { bg: 'alpha.500', textDecoration: 'none' },
  },
  flexSportName: {
    align: 'center',
    fontSize: 'sm',
    fontWeight: 'medium',
    gap: '1',
    color: 'white',
    fontFamily: 'accent',
  },
  iconSportName: { fontSize: '2xl', color: 'alpha.700', sx: {} },
  hStack: {
    spacing: '1',
    sx: {
      '.chakra-badge': {
        lineHeight: 'normal',
      },
    },
  },
  countdown: {
    color: 'inherit',
    fontSize: '9px',
    h: '16px',
    py: '0',
    sx: {
      '&&': {
        textTransform: 'lowercase',
      },
    },
  },
  duotoneSgmLogoOverride: {
    h: 'auto',
    w: '8',
    color: 'beta.200',
    sx: {
      '> svg': {
        h: '4',
        w: '8',
        color: 'beta.200',
        mb: '0.5',
      },
    },
  },
  hStackIcon: {
    as: ChevronRight,
    color: 'white',
    fontSize: '2xl',
    sx: {},
  },
};
